/* Status en signaal van een offerte als label: dezelfde kleuren in lijst en pagina. */

import { cn } from '@/lib/utils';
import { WEERGAVE_KLEUR, WEERGAVE_LABEL, type Signaal, type Weergave } from '../data/status';

export function StatusLabel({ weergave, className }: { weergave: Weergave; className?: string }) {
  return (
    <span className={cn('inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold', WEERGAVE_KLEUR[weergave], className)}>
      {WEERGAVE_LABEL[weergave]}
    </span>
  );
}

/** 'verloopt morgen' in oranje, 'verlopen' in rood. `kort` laat bij verloopt alleen de dagen zien. */
export function SignaalLabel({ signaal, kort }: { signaal: Signaal; kort?: boolean }) {
  const tekst = kort && signaal.soort === 'verloopt'
    ? signaal.dagen === 0 ? 'vandaag' : signaal.dagen === 1 ? 'morgen' : `${signaal.dagen} dgn`
    : signaal.tekst;
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded px-1.5 py-px text-[11px] font-medium',
        signaal.soort === 'verlopen' ? 'bg-red-50 text-red-700' : 'bg-amber-50 text-amber-800',
      )}
      title={signaal.tekst}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', signaal.soort === 'verlopen' ? 'bg-red-500' : 'bg-amber-500')} aria-hidden />
      {tekst}
    </span>
  );
}
